export const products = [
  // --- KANJEEVARAM SILK (category: 1) ---
  {
    id: 1,
    name: 'Royal Crimson Gold Zari Kanjeevaram Silk Saree',
    category: 1,
    mrp: 48500,
    price: 38500,
    rating: 4.9,
    fabric: 'Pure Mulberry Silk & Pure Gold Zari',
    craft: 'Korvai Handloom Weaving',
    occasion: 'Bridal & Grand Wedding',
    inStock: true,
    isBestSeller: true,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733975-2342df2f22b7?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Woven with pure Mulberry silk and rich 24k gold pure zari work featuring classic peacock motifs along the opulent korvai border.',
  },
  {
    id: 2,
    name: 'Emerald Green Temple Border Kanjivaram',
    category: 1,
    mrp: 52000,
    price: 42000,
    rating: 4.9,
    fabric: 'Pure Silk',
    craft: 'Temple Gopuram Weave',
    occasion: 'Festive & Ceremony',
    inStock: true,
    isBestSeller: false,
    isNewArrival: true,
    images: [
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'A masterpiece in deep bottle green with traditional temple (Gopuram) border detailing in contrasting golden zari threads.',
  },
  {
    id: 3,
    name: 'Mustard Gold & Magenta Pure Silk Saree',
    category: 1,
    mrp: 42000,
    price: 34500,
    rating: 4.8,
    fabric: 'Mulberry Silk',
    craft: 'Rudraksh & Coin Zari Weave',
    occasion: 'Festive & Puja',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Vibrant mustard silk body with dual-tone magenta pallu, featuring intricate rudraksh and coin zari weaves.',
  },

  // --- BANARASI SILK (category: 2) ---
  {
    id: 4,
    name: 'Midnight Navy Kadwa Banarasi Brocade Saree',
    category: 2,
    mrp: 36000,
    price: 29500,
    rating: 4.8,
    fabric: 'Kattan Pure Silk',
    craft: 'Handwoven Kadwa Technique',
    occasion: 'Wedding Reception',
    inStock: true,
    isBestSeller: true,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Authentic handwoven Banarasi Kattan silk adorned with detailed silver and gold floral Jaal work using the ancient Kadwa technique.',
  },
  {
    id: 5,
    name: 'Pastel Pink Meenakari Banarasi Silk',
    category: 2,
    mrp: 39000,
    price: 32000,
    rating: 4.9,
    fabric: 'Organza Kattan Silk',
    craft: 'Multi-Color Meenakari Weave',
    occasion: 'Sangeet & Day Events',
    inStock: true,
    isBestSeller: false,
    isNewArrival: true,
    images: [
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Soft pastel pink body decorated with delicate multi-colored Meenakari floral bootis and silver tissue zari pallu.',
  },

  // --- BRIDAL & HERITAGE COLLECTION (category: 3) ---
  {
    id: 6,
    name: 'Heritage Scarlet Red Zardozi Bridal Saree',
    category: 3,
    mrp: 80000,
    price: 65000,
    rating: 5.0,
    fabric: 'Raw Silk',
    craft: 'Hand Zardozi & Dabka Embroidery',
    occasion: 'Bridal / Main Wedding',
    inStock: true,
    isBestSeller: true,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1583391733975-2342df2f22b7?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'An heirloom wedding creation in raw silk featuring hand-embroidered dabka, zardozi, and pearls across heavy scalloped borders.',
  },
  {
    id: 7,
    name: 'Traditional Royal Temple Jewelry Set',
    category: 3,
    mrp: 58000,
    price: 48000,
    rating: 4.9,
    fabric: '22k Gold Plated Brass & Burmese Rubies',
    craft: 'Nakas Hand Carving',
    occasion: 'Bridal & Heritage Ceremonies',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733975-2342df2f22b7?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Antiqued 22k gold-plated temple necklace set crafted with hand-carved Goddess Lakshmi motifs and Burmese rubies.',
  },

  // --- CHANDERI & ORGANZA (category: 4) ---
  {
    id: 8,
    name: 'Sheer Ivory Hand-Painted Organza Saree',
    category: 4,
    mrp: 23000,
    price: 18500,
    rating: 4.7,
    fabric: 'Pure Silk Organza',
    craft: 'Hand-Painted & Gota Patti Work',
    occasion: 'Cocktail & Day Soirée',
    inStock: true,
    isBestSeller: false,
    isNewArrival: true,
    images: [
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Lightweight sheer silk organza adorned with hand-painted botanical blooms and delicate Gota Patti border embellishments.',
  },
  {
    id: 9,
    name: 'Mint Green Chanderi Silk Cotton Saree',
    category: 4,
    mrp: 17500,
    price: 14200,
    rating: 4.8,
    fabric: 'Chanderi Silk Cotton',
    craft: 'Hand Block Print & Tissue Zari',
    occasion: 'Festive Wear',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Breezy Chanderi tissue weave with subtle gold zari stripes and hand-block floral prints along the pallu.',
  },

  // --- TUSSAR & SOFT SILK (category: 5) ---
  {
    id: 10,
    name: 'Natural Honey Gold Tussar Silk Saree',
    category: 5,
    mrp: 21000,
    price: 16800,
    rating: 4.9,
    fabric: 'Wild Tussar Silk',
    craft: 'Hand Kantha Stitching',
    occasion: 'Cultural & Formal Gatherings',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Unbleached wild Tussar silk featuring authentic hand-painted Kantha stitch border art and rustic texture.',
  },

  // --- BANDHANI & PATOLA (category: 6) ---
  {
    id: 11,
    name: 'Hand-Tied Rai Bandhej Silk Saree in Vermillion',
    category: 6,
    mrp: 30000,
    price: 24500,
    rating: 4.8,
    fabric: 'Georgette Silk',
    craft: 'Rai Bandhani Tie-Dye',
    occasion: 'Festive & Haldi/Mehendi',
    inStock: true,
    isBestSeller: true,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733975-2342df2f22b7?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Traditional Gujarati Bandhani meticulously hand-tied on pure Georgette silk base with Zari woven border.',
  },

  // --- GEORGETTE & CHIFFON (category: 7) ---
  {
    id: 12,
    name: 'Peach Blossom Embroidered Pure Georgette',
    category: 7,
    mrp: 24000,
    price: 19800,
    rating: 4.7,
    fabric: 'Pure Georgette',
    craft: 'Chikankari & Sequin Threadwork',
    occasion: 'Cocktail & Evening Parties',
    inStock: true,
    isBestSeller: false,
    isNewArrival: true,
    images: [
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Fluid lightweight georgette drape styled with soft thread Chikankari embroidery and sequin highlights.',
  },

  // --- DESIGNER PARTY WEAR (category: 8) ---
  {
    id: 13,
    name: 'Midnight Black Sequined Draped Saree',
    category: 8,
    mrp: 28000,
    price: 22500,
    rating: 4.9,
    fabric: 'Poly Georgette Blend',
    craft: 'Micro-Sequin Embellishment',
    occasion: 'Sangeet & Night Parties',
    inStock: true,
    isBestSeller: true,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Contemporary party saree coated with micro-shimmer tone-on-tone sequins paired with a designer statement blouse piece.',
  },

  // --- HANDLOOM COTTON SILK (category: 9) ---
  {
    id: 14,
    name: 'Indigo Jamdani Handloom Cotton Silk',
    category: 9,
    mrp: 14500,
    price: 11500,
    rating: 4.8,
    fabric: 'Bengal Handloom Cotton Silk',
    craft: 'Jamdani Supplementary Weft',
    occasion: 'Workwear & Casual Chic',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Breathable hand-loomed Bengal Jamdani saree featuring intricate geometric weave patterns in rich indigo dye.',
  },

  // --- PAITHANI SILKS (category: 10) ---
  {
    id: 15,
    name: 'Peacock Motif Yeola Paithani Silk',
    category: 10,
    mrp: 44000,
    price: 36000,
    rating: 5.0,
    fabric: 'Pure Silk & Gold Zari',
    craft: 'Yeola Tapestry Weave',
    occasion: 'Traditional Weddings',
    inStock: true,
    isBestSeller: true,
    isNewArrival: true,
    images: [
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Vibrant purple silk drape boasting a pure gold zari woven Mor (Peacock) pallu and traditional narali border.',
  },

  // --- LINEN & MODAL SILK (category: 11) ---
  {
    id: 16,
    name: 'Pastel Yellow Zari Grid Linen Saree',
    category: 11,
    mrp: 11000,
    price: 8900,
    rating: 4.7,
    fabric: '100-Count Organic Linen',
    craft: 'Silver Zari Grid Weave',
    occasion: 'Summer Festive & Daytime',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Organic 100-count linen saree crafted with silver check zari grid patterns and silver tassels on the pallu edge.',
  },

  // --- PRINTED & DIGITAL DRAPES (category: 12) ---
  {
    id: 17,
    name: 'Kalamkari Hand-Block Printed Satin Silk',
    category: 12,
    mrp: 16500,
    price: 13500,
    rating: 4.8,
    fabric: 'Satin Silk',
    craft: 'Natural Vegetable Dye Kalamkari Block Print',
    occasion: 'Art & Cultural Outings',
    inStock: true,
    isBestSeller: false,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Smooth satin silk featuring traditional Andhra Kalamkari mythological artwork in natural organic vegetable dyes.',
  },

  // --- READY-TO-WEAR SAREES (category: 13) ---
  {
    id: 18,
    name: 'Pre-Stitched Metallic Bronze Pleated Saree',
    category: 13,
    mrp: 22000,
    price: 17800,
    rating: 4.8,
    fabric: 'Metallic Poly-Lycra Blend',
    craft: 'Accordion Pleating & Pre-stitched Waistband',
    occasion: 'Party & Cocktail',
    inStock: true,
    isBestSeller: false,
    isNewArrival: true,
    images: [
      'https://images.unsplash.com/photo-1610030469668-932def9c663d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357605129-26f69add5d6e?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1609357602329-373307223b20?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Instant ready-to-wear pre-pleated drape with adjustable waist band in metallic shimmer accordion pleats.',
  },

  // --- ROYAL VELVET SAREES (category: 14) ---
  {
    id: 19,
    name: 'Deep Wine Embroidered Velvet Half Saree',
    category: 14,
    mrp: 34000,
    price: 27500,
    rating: 4.9,
    fabric: 'Micro Velvet & Organza Silk',
    craft: 'Gota Patti & Antique Tilla Embroidery',
    occasion: 'Winter Wedding & Gala',
    inStock: true,
    isBestSeller: true,
    isNewArrival: false,
    images: [
      'https://images.unsplash.com/photo-1583391733975-2342df2f22b7?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=800',
    ],
    description: 'Plush velvet pallu paired with organza silk pleats, embellished with heavy gota patti and antique tilla embroidery.',
  },
];